// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNav-cls1_xS1","cls2":"FocusedNav-cls2_1JB FocusedNav-cls1_xS1"};